module.exports = __webpack_public_path__ + "static/media/chorthippus_vagans_003_APA.2a89b61f.mp3";